import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  Form,
} from "reactstrap";

interface AlertModalProps {
  isOpen: boolean;
  toggle: () => void;
  message: string;
  onConfirm: (reason?: string) => void;
  onCancel: () => void;
  showReasonInput?: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  toggle,
  message,
  onConfirm,
  onCancel,
  showReasonInput = false,
}) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(showReasonInput ? reason : undefined);
    setReason("");
  };

  const handleCancel = () => {
    onCancel();
    setReason("");
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <p>{message}</p>
        {showReasonInput && (
          <Form>
            <Label for="reasonInput">Reason:</Label>
            <Input
              id="reasonInput"
              type="textarea"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter the reason for denial"
            />
          </Form>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleConfirm}>
          Yes
        </Button>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AlertModal;
